export function generateSecureRandomString(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    const array = new Uint8Array(length);
    window.crypto.getRandomValues(array);
  
    return Array.from(array, byte => characters[byte % charactersLength]).join('');
}
  